import { faFaceAwesome } from '@fortawesome/pro-solid-svg-icons'

import { Alert } from 'Components/_theme'

import { Heading } from '../Heading/Heading'
import {
  ALERT_COLORS,
  ALERT_COLORS_INFO_1,
  ALERT_COLORS_INFO_2,
  ALERT_COLORS_INFO_3,
} from './Alert.constants'
import { AlertVariant } from './Alert.types'

export const AlertPresentation = () => {
  /* *** Simple Alert *** */

  const renderAlert = () =>
    ALERT_COLORS.map(variant => (
      <Alert className="ms-6" variant={variant as AlertVariant}>
        A simple alert!
      </Alert>
    ))

  /* *** Simple Alert icon Left *** */

  const renderAlertIconLeft = () =>
    ALERT_COLORS.map(variant => (
      <Alert
        className="ms-6"
        iconLeft={faFaceAwesome}
        variant={variant as AlertVariant}
      >
        A simple alert!
      </Alert>
    ))

  /* *** Simple Alert Icon Right *** */

  const renderAlertIconRight = () =>
    ALERT_COLORS.map(variant => (
      <Alert
        className="ms-6"
        iconRight={faFaceAwesome}
        variant={variant as AlertVariant}
      >
        A simple alert!
      </Alert>
    ))

  /* *** Simple Alert Icon Both *** */

  const renderAlertIconBoth = () =>
    ALERT_COLORS.map(variant => (
      <Alert
        className="ms-6"
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        variant={variant as AlertVariant}
      >
        A simple alert!
      </Alert>
    ))

  /* *** Simple Alert Info *** */

  const renderAlertInfo1 = () =>
    ALERT_COLORS_INFO_1.map(variant => (
      <Alert title="Well done!" variant={variant as AlertVariant}>
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  const renderAlertInfo2 = () =>
    ALERT_COLORS_INFO_2.map(variant => (
      <Alert title="Well done!" variant={variant as AlertVariant}>
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))
  const renderAlertInfo3 = () =>
    ALERT_COLORS_INFO_3.map(variant => (
      <Alert title="Well done!" variant={variant as AlertVariant}>
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  /* *** Simple Alert Info Icon left *** */

  const renderAlertInfoIconLeft1 = () =>
    ALERT_COLORS_INFO_1.map(variant => (
      <Alert
        iconLeft={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  const renderAlertInfoIconLeft2 = () =>
    ALERT_COLORS_INFO_2.map(variant => (
      <Alert
        iconLeft={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))
  const renderAlertInfoIconLeft3 = () =>
    ALERT_COLORS_INFO_3.map(variant => (
      <Alert
        iconLeft={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  /* *** Simple Alert Info Icon Right *** */

  const renderAlertInfoIconRight1 = () =>
    ALERT_COLORS_INFO_1.map(variant => (
      <Alert
        iconRight={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  const renderAlertInfoIconRight2 = () =>
    ALERT_COLORS_INFO_2.map(variant => (
      <Alert
        iconRight={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  const renderAlertInfoIconRight3 = () =>
    ALERT_COLORS_INFO_3.map(variant => (
      <Alert
        iconRight={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  /* *** Simple Alert Info Icon Both *** */

  const renderAlertInfoIconBoth1 = () =>
    ALERT_COLORS_INFO_1.map(variant => (
      <Alert
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  const renderAlertInfoIconBoth2 = () =>
    ALERT_COLORS_INFO_2.map(variant => (
      <Alert
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  const renderAlertInfoIconBoth3 = () =>
    ALERT_COLORS_INFO_3.map(variant => (
      <Alert
        iconLeft={faFaceAwesome}
        iconRight={faFaceAwesome}
        title="Well done!"
        variant={variant as AlertVariant}
      >
        Aww yeah, you successfully read this important alert message. This
        example text is going to run a bit longer so that you can see how
        spacing within an alert works with this kind of content.
        <hr />
        Whenever you need to, be sure to use margin utilities to keep things
        nice and tidy.
      </Alert>
    ))

  return (
    <div>
      <Heading size={4}> Alert:</Heading>

      {/* *** Simple Alert *** */}

      <Heading className="pt-4" size={6}>
        Simple Alert:
      </Heading>

      <div className="d-flex pt-4 ms-n4">{renderAlert()}</div>

      {/* *** Simple Alert Icon Left *** */}

      <Heading className="pt-4" size={6}>
        Alert Icon Left:
      </Heading>

      <div className="d-flex pt-4 ms-n4">{renderAlertIconLeft()}</div>

      {/* *** Simple Alert Icon Right *** */}

      <Heading className="pt-4" size={6}>
        Alert Icon Right:
      </Heading>

      <div className="d-flex pt-4 ms-n4">{renderAlertIconRight()}</div>

      {/* *** Simple Alert Icon Both *** */}

      <Heading className="pt-4" size={6}>
        Alert Icon Both:
      </Heading>

      <div className="d-flex pt-4 ms-n4">{renderAlertIconBoth()}</div>

      <hr className="hr-presentation" />

      {/* *** Simple Alert Info *** */}

      <Heading className="pt-4" size={6}>
        Alert Icon Info:
      </Heading>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfo1()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfo2()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfo3()}
      </div>

      <hr className="hr-presentation" />

      {/* *** Simple Alert Info Icon Left *** */}

      <Heading className="pt-4" size={6}>
        Alert Info Icon Left:
      </Heading>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconLeft1()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconLeft2()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconLeft3()}
      </div>

      <hr className="hr-presentation" />

      {/* *** Simple Alert Info Icon Right *** */}

      <Heading className="pt-4" size={6}>
        Alert Info Icon Righ:
      </Heading>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconRight1()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconRight2()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconRight3()}
      </div>

      <hr className="hr-presentation" />

      {/* *** Alert Info Icon Both *** */}

      <Heading className="pt-4" size={6}>
        Alert Info Icon Both:
      </Heading>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconBoth1()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconBoth2()}
      </div>

      <div className="d-flex pt-4 ms-n4 justify-content-sm-around">
        {renderAlertInfoIconBoth3()}
      </div>
    </div>
  )
}
